import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {
    ProfessionalExpertiseSubmit,
    ProfessionalExpertiseVerbose
} from '@app/modules/talent-track/talent-track-edit-employee/edit-employee/components/employee-details/components/employee-professional-expertises/models/professional-expertise.model';
import { catchError, map } from 'rxjs/operators';
import { api_routes } from '@app/consts';
import { EnvironmentService } from "@app/core/services/environment.service";


const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class EmployeeProfessionalExpertiseService {

  constructor(private http: HttpClient, private envService: EnvironmentService) {}

  getProfessionalExpertises(employeeId: string, take?: number, skip?: number, sort?: string): Observable<any> {
    let params = new HttpParams();
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;
    sort ? params = params.append('sort', sort) : null;

    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.PROFESSIONAL_EXPERTISES}`, {
      headers: headers,
      params: params
    })
    .pipe(
      catchError(err => throwError(err)),
      map(res => {
        let data = {
          data: res.data,
          total: res.total
        }

        return data;
      })
    );
  }

  deleteProfessionalExpertise(employeeId: string, id: string): Observable<any> {
    return this.http.delete<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.PROFESSIONAL_EXPERTISES}/${id}`, {
      headers: headers
    });
  }

  getProfessionalExpertise(employeeId: string, id: string): Observable<ProfessionalExpertiseVerbose> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.PROFESSIONAL_EXPERTISES}/${id}`, {
      headers: headers
    });
  }

  updateProfessionalExpertise(employeeId: string, employeeProfessionalExpertise: ProfessionalExpertiseSubmit): Observable<any> {
    return this.http.put<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.PROFESSIONAL_EXPERTISES}/${employeeProfessionalExpertise.id}`, employeeProfessionalExpertise, {
      headers: headers
    });
  }

  createProfessionalExpertise(employeeId: string, employeeProfessionalExpertise: ProfessionalExpertiseSubmit): Observable<any> {
    return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.PROFESSIONAL_EXPERTISES}`, employeeProfessionalExpertise, {
      headers: headers
    });
  }
}
